import React, { Component } from "react";
class DialogInput extends React.Component
{
    
    constructor(props)
    {
        super(props);
        this.state =
        {
            value: this.props.value,
            errmsg: this.props.errmsg,
        }

    }

    setErrorMsg(msg)
    {
        this.setState({errmsg:msg});
    }

    componentDidUpdate(prevProps)
    {
        if (this.props.value !== prevProps.value)
            this.setState({value:this.props.value})
        if (this.props.onChange) this.props.onChange();
    }

    setValue(text)
    {
        if (text != this.state.value)
            this.setState({value:text})
    }


    getValue()
    {
        return this.state.value.toString().trim();
    }

    render()
    {
        var msg="";
        if (this.state.errmsg != "")
        {
            msg=(
                <span style={{borderRadius:"3px",marginLeft:"12px",color:"white", borderStyle:"solid", borderColor:"red", borderWidth:"1px"}}
                    >
                &nbsp;&nbsp;{this.state.errmsg}&nbsp;&nbsp;
                </span>
            )
        }

        if (this.props.nbline == 1)
        {

            return (<>
                <div className = "dialog-Input-Title">
                    {this.props.title}{msg}
                </div>
                <input className="dialog-Input-Datas" autoFocus={this.props.autoFocus}
                        type="text"

                        readOnly={this.props.readOnly}
                        disabled={this.props.disabled}
                        onKeyDown={e=>{e.stopPropagation()}}
                        onChange = {e => {
                            this.setState({value:e.target.value});
                            console.log("change value",e)
                            if (this.props.onChangeValue) this.props.onChangeValue(e.target.value);
                            }
                        }
                        value={this.state.value}
                        style = {{width: this.props.width, textAlign: this.props.align}}
                        required />
                
            </>);
        }
        return (<>
            <div className = "dialog-Input-Title">
                {this.props.title}{msg}
            </div>
            <textarea className="dialog-Input-Datas-Multiline" autoFocus={this.props.autoFocus}
                    type="text"
                    rows = {this.props.nbline}
                    readOnly={this.props.readOnly}
                    disabled={this.props.disabled}
                    onChange={e => this.setState({value:e.target.value})}
                    onKeyDown={e=>{e.stopPropagation()}}
                    value={this.state.value}

                    style = {{width: this.props.width, resize:"none", textAlign: this.props.align}}
                    required />
            
        </>);
    
    }

}
DialogInput.defaultProps = 
{
    align: "left",
    autoFocus: false,
    readOnly: false,
    disabled: false,
    nbline: 1,
    errmsg: "",
}

export default DialogInput